<template>
  <v-layout align-center>
    <v-flex grow py-0>
      <v-text-field
        id="discount-code"
        v-model="discount.code"
        minlength="3"
        @blur="onCodeChange(discount.code)"
        @keyup.enter="onCodeChange(discount.code)"
        :disabled="discount.loading || !!discount.rate"
        :error-messages="discount.errors.code"
        :label="$t('CART.DISCOUNT_CODE')"
        :loading="discount.loading"
      >
        <template v-if="discount.rate" v-slot:prepend-inner>
          <v-icon size="20" class="mr-2" color="green">fas fa-check</v-icon>
        </template>
        <template v-slot:append>
          <span v-if="discount.rate">
            <span>{{ discount.rate}}</span>
            <span v-if="discountAmount" class="ml-1">({{ discountAmount }})</span>
          </span>
          <v-icon
            v-else
            size="20"
            color="primary"
            class="mr-2"
            @click="onCodeChange(discount.code)"
          >fas fa-sign-in-alt</v-icon>
        </template>
      </v-text-field>
    </v-flex>
    <v-flex py-0 px-0 shrink v-if="discount.rate">
      <v-btn class="ma-0 mr-2" icon @click="clearInput">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<style type="text/css">
</style>

<script>
import debounce from "@/utils/TinyDebounce";

export default {
  /**
   * Since the discount amount comes from cart/details request
   * Lets get it as prop from parent component
   */
  props: ["discountAmount"],

  data() {
    return {
      discount: {}
    };
  },

  created() {
    this.resetInput();
  },

  methods: {
    resetInput() {
      this.discount = {
        code: null,
        errors: {},
        loading: false,
        rate: null
      };
    },

    clearInput() {
      console.log("clear input");
      this.resetInput();
      this.$emit("onDiscountSuccess", null);
    },

    async onCodeChange(e) {
      if (!e || e.length < 3) return;
      this.discount.loading = true;
      // reset discount related data
      this.discount.errors = {};
      this.discount.rate = null;

      try {
        const res = await this.$axios.post(`/cart/discount-coupon`, {
            artworks: this.$cart.items.map((item) => item.id),
            code: e,
        });

        this.discount.rate = res.data.data.discount_rate;
        this.$emit("onDiscountSuccess", this.discount.code);
      } catch (error) {
        if (error.status === 422 && error.data) {
          this.discount.errors = error.data.errors;
        }
      }
      this.discount.loading = false;
    }
  }
};
</script>
